export default __webpack_public_path__ + "static/media/81.12676fd6.png";